import { Pipe, PipeTransform } from '@angular/core';

import { SortDirection } from '../coaching-insight/oa/models/sorting.model';

import { Sort } from './user-login.reports.model';

@Pipe({
    name: 'sortArrowReports',
})
export class ReportsSortArrow implements PipeTransform {
    transform(type: Sort, field: string): any {
        if (type.active === field) {
            switch (type.direction) {
                case SortDirection.ASC:
                    return 'chevron-up';
                case SortDirection.DESC:
                    return 'chevron-down';
            }
        }
        return 'unfold-more-horizontal';
    }
}
